import {useMemo, useState} from "react";

import {useQuery} from "@tanstack/react-query";

import {ReviewChoice} from "@globals/DailyOrders/interfaces";

import {getReviewChoices} from "../DishReviewService";

type ReviewChoicesResource = {
  availableChoices: ReviewChoice[];
  isLoading: boolean;
  selectedChoices: number[];
  formattedChoices?: {id: number}[];
  setSelectedChoices: (choices: number[]) => void;
  setChoicesRating: (rating: number) => void;
};

export default function useReviewChoices(
  initialRating = 0
): ReviewChoicesResource {
  const [rating, setRating] = useState(initialRating);
  const [selectedChoices, setSelectedChoices] = useState<number[]>([]);

  const {data, isPending} = useQuery({
    queryKey: ["reviewChoices", rating],
    queryFn: () => getReviewChoices(rating),
    enabled: Boolean(rating),
  });

  const formattedChoices = useMemo(() => {
    // filter out choices that are not in the data
    // format the choices to match the API request
    if (data) {
      return selectedChoices
        .filter((id) => data.find((choice) => choice.id === id))
        .map((choiceId) => ({id: choiceId}));
    }
  }, [data, selectedChoices]);

  return {
    availableChoices: data || [],
    isLoading: isPending,
    selectedChoices,
    formattedChoices,
    setSelectedChoices,
    setChoicesRating: setRating,
  };
}
